import React, { Component } from 'react';
import { sanitize } from 'dompurify';
import { Link } from 'react-router-dom';
import Slider from '../../hocs/Slider/Slider';
import { addEvent, removeEvent } from '../../utils/dom';
import s from './Text.scss';

class Text extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isMobile: window.innerWidth <= 1100,
		};
	}

	componentDidMount() {
		let { isMobile } = this.state;

		const resizeEvent = () => {
			const width = window.innerWidth;
			if (isMobile && width > 1100) {
				isMobile = false;
				this.setState({
					isMobile: false,
				});
			} else if (!isMobile && width <= 1100) {
				isMobile = true;
				this.setState({
					isMobile: true,
				});
			}
		};

		addEvent(window, 'resize.mobileImages', () => {
			window.requestAnimationFrame(resizeEvent);
		});

		resizeEvent();
	}

	componentWillUnmount() {
		removeEvent(window, 'resize.mobileImages');
	}

	render() {
		const { textPage, title, setup, sideMenuPage, previousPage, pagePath } = this.props;
		const { isMobile } = this.state;

		return (
			<div className={s.text}>
				{
					isMobile && textPage.images.length > 0 ? (
						<div id="js-productImages" className={s.text_images}>
							<Slider adaption="textPage" infinite screenMaxWidthDisable={1100} showArrows={false}>
								{
									textPage.images.map(media => (
										<div key={media.src.slice(media.src.lastIndexOf('/') + 1)} className={s.text_images_media}>
											<img className={s.text_images_media_image} src={media.src} alt={media.alt} />
										</div>
									))
								}
							</Slider>
						</div>
					) : null
				}
				<div className={[s.text_info, ...(sideMenuPage ? [s.text_info__sideMenuPage] : []), s[`text_info__${pagePath}`]].join(' ')}>
					<h1 className={s.text_info_title}>{title}</h1>
					{
						textPage.textSection.map((section, i) => (
							<div key={i} className={s.text_info_section}>
								{ section.subHeading ? <h4 className={s.text_info_section_title}>{section.subHeading}</h4> : null }
								<div dangerouslySetInnerHTML={{ __html: sanitize(section.text) }} />
							</div>
						))
					}
					{ sideMenuPage ? <Link className={s.text_info_close} to={previousPage}>[{setup.static.close}]</Link> : null }
				</div>
			</div>
		);
	}
}

export default Text;



// WEBPACK FOOTER //
// ./components/Text/Text.jsx